import type { AccessoryPopDetail } from '@/apis/dp/api.interface';
import { getFloorDetailData } from '@/apis/dp/apiClient';
import { AccessoryConfig } from '@/apis/dp/floor.interface';
import CouponSvg2 from '@/assets/icons/dp-coupon-2.svg';
import CDNImage from '@/components/cdnImage/cdnImage';
import UKDrawer from '@/components/UKDrawer';
import UKPageNothing from '@/components/UKPageNothing';
import { useTranslation } from '@/i18n/client';
import ArrowIcon from '@/images/icon/arrow-default.svg';
import { formatProductLink } from '@/utils/formatProductLink';
import clsx from 'clsx';
import { useState } from 'react';
import styles from './index.module.scss';

type Props = {
  data: AccessoryConfig;
  mainSkuId: string;
};

export default function MarketActivity({ data, mainSkuId }: Props) {
  const [openDraw, setOpenDraw] = useState(false);
  const [detailData, setDetailData] = useState<AccessoryPopDetail>();

  const { desc, useStatus, popTitle, promotionType, promotionTags, subType, promotionId } = data;

  const { popDesc, detailList } = detailData || {};
  const { t } = useTranslation();

  const handleDrawerClose = () => {
    setOpenDraw(false);
  };

  const fetchDetailData = async () => {
    const res = await getFloorDetailData({
      floorId: 'productGiftPopFloor',
      skuId: mainSkuId, // 这里应该使用实际的 skuId
      promotionType,
      promotionTags,
      subType,
      promotionId,
    });
    setDetailData(res?.data?.data?.popDetail);
  };

  const openListDraw = async () => {
    await fetchDetailData();
    setOpenDraw(true);
  };

  const openItemDetail = (skuId: string) => {
    // 在新标签页中打开商品详情页
    window.open(formatProductLink(skuId), '_blank');
  };

  return (
    <div>
      <div className={styles.itemBox} onClick={openListDraw}>
        <CouponSvg2 />
        <span className={styles.desc}>{desc}</span>
        <span className={styles.useStatus}>{useStatus}</span>
        <span className={styles.arrow}>
          <ArrowIcon />
        </span>
      </div>
      <UKDrawer
        width={430}
        height={'100%'}
        openDrawer={openDraw}
        handleClose={handleDrawerClose}
        title={popTitle}
      >
        <div className={styles.detailContainer}>
          <div className={styles.popDesc}>{popDesc}</div>
          {detailList?.length ? (
            <>
              {detailList?.map((item) => {
                const { skuId, outOfStockStatus, imageUrl, skuName, outOfStockDesc, num } = item;
                return (
                  <div
                    className={clsx(styles.detailItem, {
                      // [styles.outOfStockBox]: outOfStockStatus,
                    })}
                    key={skuId}
                    // exptag={'exp|' + EXPOSURE_RECORD.Productdetail_Storepicks_Products_Expo}
                    // data-exptag-config={dataExpTagConfig}
                    // data-exptag-json-param={JSON.stringify(itemTrackParams)}
                    // onClick={() => {
                    //   sendClickTrack.Productdetail_Storepicks_Products_Click(itemTrackParams);
                    // }}
                    onClick={() => openItemDetail(skuId)}
                  >
                    <CDNImage
                      src={imageUrl}
                      width={120}
                      height={120}
                      alt='product_img'
                      style={{
                        width: '120px',
                        height: '120px',
                        borderRadius: '4px',
                        opacity: outOfStockStatus ? 0.5 : 1,
                        objectFit: 'contain',
                      }}
                    />
                    <div className={styles.itemRight}>
                      <div className={styles.skuName}>{skuName}</div>
                      {!outOfStockStatus && <div className={styles.num}>x{num}</div>}
                      {outOfStockStatus && outOfStockDesc && (
                        <div className={styles.outOfStockDesc}>{outOfStockDesc}</div>
                      )}
                    </div>
                    {outOfStockStatus && <div className={styles.outOfStockMask}></div>}
                  </div>
                );
              })}
            </>
          ) : (
            <UKPageNothing text={t('common.pageStatus.refresh')} textStyle={{ width: '100%' }} />
          )}
        </div>
      </UKDrawer>
    </div>
  );
}
